import { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";

export default function Sale() {
  const t = useTranslations("Home");

  return (
    <div className="relative w-full flex flex-col-reverse xl:flex-row-reverse rtl:xl:items-center justify-center overflow-hidden mt-10 min-h-132.5">
      {/* IMAGE */}
      <div className="relative w-full xl:w-1/2 h-87.5 md:h-150">
        <Image
          // src={locale === "en" ? "/sale-hero.webp" : "/sale-ar-hero.webp"}
          src={`/hero.png`}
          alt="Sale Img"
          fill
          priority
          quality={90}
        />
      </div>

      {/* CONTENT */}
      <div className="w-full xl:w-1/2 bg-[#FBFBFB] min-h-95 md:min-h-132.5 flex flex-col justify-center gap-8 px-6 sm:px-14 md:px-40 lg:px-52 select-none">
        <div className="relative">
          <h4 className="text-base sm:text-lg md:text-xl font-bold uppercase tracking-widest">
            {t("dream")}
          </h4>
          <h2 className="font-bold text-main text-4xl sm:text-5xl md:text-6xl">
            {t("sale")}
          </h2>

          <span className="absolute -bottom-3 w-37.5 rtl:w-20 h-1.5 bg-black"></span>
          <span className="hidden md:block absolute top-0 -left-20 rtl:-right-20 w-10 h-10 bg-main"></span>
        </div>

        <div>
          <p className="text-[#606060] text-sm sm:text-base">{t("dreamDes")}</p>

          <div className="mt-8">
            <h4 className="font-bold text-sm sm:text-base uppercase tracking-widest">
              {t("price")}
            </h4>
            <div className="flex items-center gap-2">
              <h2 className="font-bold text-4xl sm:text-5xl text-main">
                360,000
              </h2>
              <Image
                src={"/sar.png"}
                alt="SAR"
                width={24}
                height={24}
                className="inline-block ml-2 mb-2"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
